<template>
  <el-radio class="registerCheckButton relative" :label="value" border
    ><div
      :class="[currValue === value ? 'selected text-blueG0' : 'text-darkBlueG0', cssClass]"
      class="card_button flex items-center justify-center gap-2.5 hover:text-blueG0"
    >
      <slot /></div
  ></el-radio>
</template>

<script>
// Use with <el-radio-group>
export default {
  name: 'RegisterCheckButton',
  props: {
    //  slot
    currValue: {
      validator: function (value) {
        return value === null || typeof value === 'string' || typeof value === 'number';
      },
      required: true
    },
    value: { type: [String, Number], required: true },
    cssClass: { type: String, default: '' }
  }
};
</script>

<style lang="scss" scoped>
.registerCheckButton.el-radio.is-bordered ::v-deep {
  height: auto;
  border: none;
  padding: 0;
  margin: 0;
  color: inherit;
  .el-radio__label {
    padding: 0;
  }
  .el-radio__input {
    display: none;

    &.is-checked + .el-radio__label {
      color: inherit;
    }
  }

  .card_button.selected {
    background-color: rgba($color: $primary-blue, $alpha: 0.15);
    border-color: $primary-blue;
    box-shadow: 0px 0px 4px 0px $primary-blue;
    overflow: visible;
  }
}
</style>
